<template>
  <div @click="onClose" id="sideModal" class="wrapper">
    <div :class="{wrapper_body: true, open: data.open}">
      <div class="body">
        <button @click="data.open = false" type="button" class="btn btn-default closeBtn"><i
          class="icon-fa icon-fa-remove"></i>
        </button>

        <template v-if="data.type && data.type === 'createDrugTask'">
          <CreateSiteDrug
            :taskId="data.taskId"
            :closeModal="() => onClose(null, true)"
          />
        </template>
        <template v-else>
          <EditDrugBlock
            :data="data"
            :selectedDrug="{id: data.drugId}"
          />
        </template>

      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import EditDrugBlock from "@/views/nomenclature/components/EditDrugBlock";
import CreateSiteDrug from "@/views/drugs/CreateSiteDrug";
import {customUpdateData} from "@/eventsBus";

export default {
  props: ['data'],
  components: {
    EditDrugBlock,
    CreateSiteDrug,
  },
  data() {
    return {
      loading: false,
      modalData: null,
    }
  },
  mounted() {
    const body = document.getElementsByTagName('body')[0]
    body.style.overflow = 'hidden'
    this.getModalData();
  },
  beforeDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = "auto";
    if (this.data.updated) {
      customUpdateData.$emit(
        this.data?.type,
        this.data
      );
    }
  },
  methods: {
    async getModalData() {
      this.loading = true;
      switch (this.data.type) {
        case 'editDrug':
          break;
      }
      this.loading = false;
    },
    onClose(e, global = false) {
      if (global || e && e.target && e.target.id === 'sideModal') {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        this.data.open = false;
      }
    },
  }
}

</script>

<style scoped>
.body {
  background-color: #f8f8f8;
  height: 100vh;
  padding: 10px;
  overflow: auto;
}

.wrapper_body.open {
  /*left: calc(100% - 300px);*/
  left: 25%;
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  background-color: white;
  width: 75%;
  left: 100%;
  min-height: 100%;
  z-index: 9999;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 9999;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}

.closeBtn {
  z-index: 9;
  position: absolute;
  top: 10px;
  right: 10px;
}

.closeBtn i {
  text-align: center;
}

.loading {
  padding-top: 50px;
}
</style>
